export default __webpack_public_path__ + "static/media/slider_02-25_ita_mod_2.75795e39.png";